














import { Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import cloneDeep from 'clone-deep'
import Zone from '@/dto/Zone/Zone'
import HotService from '@/services/HotService'
import ZoneItemsHeader from '@/components/delivery/zone-items/ZoneItemsHeader.vue'
import layoutStore from '@/stores/LayoutStore'
import deliveryStore from '@/stores/DeliveryStore'
import Delivery from '@/dto/deliveries/Delivery'
import ZoneItem from '@/dto/Zone/ZoneItem'
import UiHandsontable from '@/components/delivery/zone-items/UiHandsontable.vue'
import Handsontable from 'handsontable'
import GridSettings = Handsontable.GridSettings
import LocationService from '@/services/LocationService'
import ZoneService from '@/services/ZoneService'
import { NotifyHelper } from 'vue-kit/helpers'

@Component({
  components: { UiHandsontable, ZoneItemsHeader },
})
export default class ZoneItems extends Vue {
  @Prop(Object)
  zone!: Zone

  @Ref('hotWrapper')
  hotWrapper!: UiHandsontable

  deliveryStore = deliveryStore
  isPending: boolean = false

  options: GridSettings = HotService.getZoneItemsSettings()

  created() {
    LocationService.getCountries()
  }

  get delivery(): Delivery {
    return this.deliveryStore.delivery as Delivery
  }

  get tableData(): ZoneItem[] {
    return cloneDeep(this.zone.items)
  }

  async saveChanges() {
    const hot = this.hotWrapper.hot as Handsontable
    const items = hot.getSourceData() as ZoneItem[]
    const itemsWithCountry = items.filter(
      item => !!item.country && !!item.country.id
    )

    if (!itemsWithCountry.length) {
      return
    }

    this.isPending = true

    ZoneService.saveZoneItems(this.zone.id, itemsWithCountry)
      .then(items => (this.zone.items = items))
      .then(() => NotifyHelper.success('Зона сохранена'))
      .catch(() => NotifyHelper.error('Ошибка сервера'))
      .finally(() => (this.isPending = false))
  }
}
